var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"app-download"},[(_vm.infoShow)?_c('p',{staticClass:"info"},[_vm._v("请跳转至默认浏览器打开本链接")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }